import angular from 'angular';
import 'angular-ui-router';
import 'ng-file-upload/dist/ng-file-upload';
import 'angular-modal-service';
import Filters from '../../filters/filters';
import template from './nativeVideoAdCreativesForm.jade';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ProgressBarSetter from '../../services/progressBarSetter';
import WebFont from 'webfontloader';
import Rx from 'rx';
import copyContentModalTemplate from './copyContentModal.jade';

export class NativeVideoAdCreativesFormController {
  /* @ngInject */
  constructor($scope, $element, $timeout, $window, currentGame, GamesResource, $stateParams, $filter, setProgressBar, ModalService, BannerPreviewResource, notify, $sce) {
    this.$scope = $scope;
    this.$sce = $sce;
    this.$window = $window;
    this.GamesResource = GamesResource;
    this.$stateParams = $stateParams;
    this.currentGame = currentGame;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.setProgressBar = setProgressBar;
    this.ModalService = ModalService;
    this.BannerPreviewResource = BannerPreviewResource;
    this.notify = notify;
    this.activeTextBlock = null;
    this.statusOptions = [
      {name: 'active', value: true},
      {name: 'inactive', value: false}
    ];
    this.mainVideoSafeUrl =
      this.$sce.trustAsResourceUrl(this.nativeVideoAdMainVideoUrl);

    this.thumbnailImageSafeUrl =
        this.$sce.trustAsResourceUrl(this.nativeVideoAdThumbnailImageUrl);

    if(!this.creative.id) {
      this.creative.active = true;
    }

    $scope.$on('scrollToCreative', (event, creativeId) => {
      if (!this.creative || String(this.creative.id) !== String(creativeId)) return;
      $timeout(() => {
        const el = $element[0];
        el.classList.add('is-highlighted');
        $timeout(() => el.classList.remove('is-highlighted'), 2000);
        this.isEditingNativeVideo = true;
        $timeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
      }, 300);
    });
  }

  toggleExpand() {
    this.isEditingNativeVideo = !this.isEditingNativeVideo;
    if (this.isEditingNativeVideo) {
      this.updateUrlWithCreativeId();
    } else {
      this.removeCreativeIdFromUrl();
    }
  }

  buildDeepLink() {
    const variationId = this.variation && this.variation.id;
    if (!variationId || !this.creative.id) return null;
    const baseUrl = this.$window.location.href.replace(/#\d+(-\d+)?$/, '');
    return baseUrl + '#' + variationId + '-' + this.creative.id;
  }

  updateUrlWithCreativeId() {
    const deepLink = this.buildDeepLink();
    if (deepLink) {
      this.$window.history.replaceState(null, '', deepLink);
    }
  }

  removeCreativeIdFromUrl() {
    const cleanedUrl = this.$window.location.href.replace(/-\d+$/, '');
    this.$window.history.replaceState(null, '', cleanedUrl);
  }

  handleNewNativeVideoAdIcon(newNativeVideoAdIcon){
    this.isLoadingNativeVideoAdIcon = true;
    if(newNativeVideoAdIcon){
      this.$scope.$emit('newFileUploaded', newNativeVideoAdIcon, this.creative, 'nativeVideoAdIcon');
      this.setProgressBar(this, 1, 1).then(() => this.isLoadingNativeVideoAdIcon = false);
    }
  }

  handleNewNativeVideoAdMainImg(newNativeVideoAdMainImg){
    this.isLoadingNativeVideoAdMainImg = true;
    if(newNativeVideoAdMainImg){
      this.$scope.$emit('newFileUploaded', newNativeVideoAdMainImg, this.creative, 'nativeVideoAdMainImg');
      this.setProgressBar(this, 1, 1).then(() => this.isLoadingNativeVideoAdMainImg = false);
    }
  }

  handleVideoMetadata(thumbVideoPlayer){
    var videoDuration = Math.floor(thumbVideoPlayer.duration);
    var height = thumbVideoPlayer.videoHeight;
    var width = thumbVideoPlayer.videoWidth;
    var lim = 50;

    var videoAspectRatio = this.findVideoAspectRatio((width/height), lim)

    this.creative.duration = videoDuration;
    this.creative.aspect_ratio = videoAspectRatio[0] + ":" + videoAspectRatio[1];

    thumbVideoPlayer.addEventListener('canplay', function() {
        this.currentTime = 1;
    });
  }

  handleNewNativeVideoAdMainVideo(nativeVideoAdMainVideo){
      this.isLoadingNativeVideoAdMainVideo = true;
      if (nativeVideoAdMainVideo){

          var thumbVideoPlayer = document.getElementById('thumb_video_player');
          thumbVideoPlayer.addEventListener('loadedmetadata', this.handleVideoMetadata.bind(this, thumbVideoPlayer));

          this.mainVideoSafeUrl =
              this.$sce.trustAsResourceUrl((window.URL || window.webkitURL).createObjectURL(nativeVideoAdMainVideo));

          this.$scope.$emit('newFileUploaded', nativeVideoAdMainVideo, this.creative, 'nativeVideoAdMainVideo');
          this.setProgressBar(this, 1, 1).then(() => this.isLoadingNativeVideoAdMainVideo = false);
      }
    }

    findVideoAspectRatio(val, lim) {

        var lower = [0, 1];
        var upper = [1, 0];

        while (true) {
            var mediant = [lower[0] + upper[0], lower[1] + upper[1]];

            if (val * mediant[1] > mediant[0]) {
                if (lim < mediant[1]) {
                    return upper;
                }
                lower = mediant;
            } else if (val * mediant[1] == mediant[0]) {
                if (lim >= mediant[1]) {
                    return mediant;
                }
                if (lower[1] < upper[1]) {
                    return lower;
                }
                return upper;
            } else {
                if (lim < mediant[1]) {
                    return lower;
                }
                upper = mediant;
            }
        }
    }

  removeCreative() {
      if (!this.creative.id) {
          let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.type == this.creative.type;});
          if (indexOfCreativeToRemove > -1) {
              this.variation.creatives.splice(indexOfCreativeToRemove,1);
          }
      } else {
          this.creative.is_deleted = true;
          return this.GamesResource.one(this.$stateParams.gameId).one('variations', this.creative.variation_id).one('creatives', this.creative.id).customPUT(this.creative)
              .then((creativeRes) => {
                  let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.id == this.creative.id;});
                  if (indexOfCreativeToRemove > -1) {
                      this.variation.creatives.splice(indexOfCreativeToRemove,1);
                  }
              });
      }
  }

  get creatives() {
    return _.chain(this.variation).map('creatives').flatten().value();
  }

  get nativeVideoAdIconUrl() {
    return this.creative.icon_image_url || _.get(this.creative, 'nativeVideoAdIcon.$ngfBlobUrl')
  }

  get nativeVideoAdMainImgUrl() {
    return this.creative.main_image_url || _.get(this.creative, 'nativeVideoAdMainImg.$ngfBlobUrl')
  }

  get nativeVideoAdMainVideoUrl() {
    return this.creative.url || _.get(this.creative, 'nativeVideoAdMainVideo')
  }

  get nativeVideoAdThumbnailImageUrl() {
    return this.creative.thumbnail_image_url;
  }

  openAdIconPreview() {
    this.showPreviewModal(this.nativeVideoAdIconUrl);
  }

  openAdMainImgPreview(){
    this.showPreviewModal(this.nativeVideoAdMainImgUrl);
  }

  openAdMainVideoPreview(){
    this.showVideoPreviewModal(this.mainVideoSafeUrl);
  }

  showPreviewModal(url){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <img ng-src="{{vm.url | adaptNonCDNHttpsUrls}}" style='margin-top: 15px;'/>
            <svg gg-icon='icon-close' style='position: absolute;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  showVideoPreviewModal(url){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++" style='position: relative;'>
            <video ng-src="{{vm.url}}" controls width='600px' ng-click="$event.stopPropagation()" style='margin-top: 15px; '/>
            <svg gg-icon='icon-close' style='position: absolute;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  isUACampaign() {
    return this.campaign.type == 'Acquisition';
  }

  isEngagementCampaign() {
    return this.campaign.type == 'Engagement';
  }

  setLineEditing(line) {
    this.creative.definition.lines.forEach((l) => l.editing = false);
    line.editing = true;
  }
}

let NativeVideoAdCreativesFormComponent = {
  template: () => { return template },
  controller: NativeVideoAdCreativesFormController,
  controllerAs: 'vm',
  bindings: {
    campaign: '=',
    creative: '=',
    variation: '=',
    disableField: '='
  }
};

export default angular.module('app.components.campaigns.nativeVideoAdCreativesForm', [
  'ngFileUpload',
  'app.services.progressBar',
  'angularModalService',
  ConfigsModule.name,
  ServicesModule.name,
  Filters.name
])
  .component('nativeVideoAdCreativesForm', NativeVideoAdCreativesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/nativeVideoAdCreativesForm.js
 **/